import { render, staticRenderFns } from "./WaitingValuesAdd.vue?vue&type=template&id=18b3c3a6&scoped=true&"
import script from "./WaitingValuesAdd.vue?vue&type=script&lang=js&"
export * from "./WaitingValuesAdd.vue?vue&type=script&lang=js&"
import style0 from "./WaitingValuesAdd.vue?vue&type=style&index=0&id=18b3c3a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b3c3a6",
  null
  
)

export default component.exports